<template>
  <div class="paymentSuccessContainer">
    <div class="grid imgGrid">
      <img class="imgContainer" src="@/assets/images/mosquita_rocket.png" />
      <p class="nunitoBold subheaderText">{{ $t('k_plan_enabled') }}</p>
      <p
        v-html="$t('k_welcome_smart')"
        class="ralewayRegular subheaderText2"
      ></p>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="grid mt-10">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="downloadSmart">
            {{ $t('k_download_smart') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  methods: {
    downloadSmart: function() {
      location.replace(
        'https://smarttales.app/get.php?lang=[in/en]&ref=couponLanding'
      )
    }
  }
}
</script>
<style lang="scss">
.paymentSuccessContainer {
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
